import { render, staticRenderFns } from "./IbCommissionTable.vue?vue&type=template&id=ff4e3456"
import script from "./IbCommissionTable.vue?vue&type=script&lang=js"
export * from "./IbCommissionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports